import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class LockIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="16" viewBox="0 0 14 16" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M7 0c2.578 0 4.667 2.046 4.667 4.571V7H14v9H0V7h2.333V4.571C2.333 2.046 4.422 0 7 0zm.017 2C5.43 2 4.35 2.984 4.35 4.429V7h5.333V4.429C9.683 2.984 8.603 2 7.017 2z"/></svg>
        )
    }
}

export default withCssClassName(LockIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/lock-icon.js